import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import TickIcon from "Assets/Icons/TickIcon";
import TickIconMB from "Assets/Icons/TickIconMB";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import { GetAssetsIF } from "Pages/MySchedule/TOCModal/MarkedLectureViewModal";
import { Spinner } from "reactstrap";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

const DivView = styled<any>("div")`
  padding: 0px 16px 12px 16px;
  height: calc(100% - 85px);
  overflow: auto;
`;
const DivViewSub = styled<any>("div")`
  padding: 8px 8px 8px 0px;
  display: flex;
  align-items: center;
  gap: 10px;
`;
const SpanStyled = styled<any>("span")`
  color: #333333;
  font-size: 16px;
`;
export interface MarkedLectureViewListingIF {
  data: GetAssetsIF[];
  Loader: boolean;
}
const MarkedLectureViewListing = ({
  data,
  Loader,
}: MarkedLectureViewListingIF) => {
  const { screen }: any = useWindowSize();
  return (
    <>
      {data && data.length == 0 ? (
        <div className="mt-4 mb-8">
          <NoResultFoundSearch
            primaryMessage="Data not found"
            secondaryMessage={
              "Seems like there was an error loading data                  "
            }
          >
            <NoDataFoundIcon />
          </NoResultFoundSearch>
        </div>
      ) : (
        <>
          {Loader ? (
            <div>
              <Spinner color="info"></Spinner>
            </div>
          ) : (
            <DivView>
              {data.map((ele: GetAssetsIF) => {
                return (
                  <DivViewSub key={ele.nodeTitle + ele.nodeId}>
                    <span>
                      {["xxl", "xl", "lg"].includes(screen) ? (
                        <TickIcon />
                      ) : (
                        <TickIconMB></TickIconMB>
                      )}
                    </span>
                    <SpanStyled>{ele.nodeTitle}</SpanStyled>
                  </DivViewSub>
                );
              })}
            </DivView>
          )}
        </>
      )}
    </>
  );
};
export default MarkedLectureViewListing;
